import { t } from "@travily/i18n";
import { FieldSet } from "@ui/components/FieldSet";
import { BudgetFilter } from "./BudgetFilter";
import { KoppenFilter, type KoppenMainClass } from "./KoppenFilter";
import { type LanguageCode, LanguageFilter } from "./LanguageFilter";
import { type TemperatureBand, TemperatureFilter } from "./TemperatureFilter";
import { TimezoneFilter, type UtcOffset } from "./TimezoneFilter";

export interface DestinationsFiltersProps {
  budgetDistribution?: number[];
  budgetValue: [number, number] | null;
  koppenValue: KoppenMainClass[];
  languageValue: LanguageCode[];
  onBudgetChange: (range: [number, number] | null) => void;
  onKoppenChange: (classes: KoppenMainClass[]) => void;
  onLanguageChange: (codes: LanguageCode[]) => void;
  onTemperatureChange: (bands: TemperatureBand[]) => void;
  onTimezoneChange: (offsets: UtcOffset[]) => void;
  temperatureValue: TemperatureBand[];
  timezoneValue: UtcOffset[];
}

export function DestinationsFilters({
  budgetDistribution,
  budgetValue,
  koppenValue,
  languageValue,
  onBudgetChange,
  onKoppenChange,
  onLanguageChange,
  onTemperatureChange,
  onTimezoneChange,
  temperatureValue,
  timezoneValue,
}: DestinationsFiltersProps) {
  return (
    <FieldSet.List size="lg">
      <FieldSet>
        <FieldSet.Legend>{t("components.views.destinations.search.budget_label")}</FieldSet.Legend>
        <BudgetFilter distribution={budgetDistribution} onChange={onBudgetChange} value={budgetValue} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.destinations.search.temperature_label")}</FieldSet.Legend>
        <TemperatureFilter onChange={onTemperatureChange} value={temperatureValue} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.destinations.search.koppen_label")}</FieldSet.Legend>
        <KoppenFilter onChange={onKoppenChange} value={koppenValue} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.destinations.search.timezone_label")}</FieldSet.Legend>
        <TimezoneFilter onChange={onTimezoneChange} value={timezoneValue} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.destinations.search.language_label")}</FieldSet.Legend>
        <LanguageFilter onChange={onLanguageChange} value={languageValue} />
      </FieldSet>
    </FieldSet.List>
  );
}
